// extracted by mini-css-extract-plugin
export default {"tag":"remainingAvailableRequests_tag__IrKzR"};